import React, { useState } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Select,
} from '@chakra-ui/react';
import { Field, getIn, useFormikContext } from 'formik';

import { daysForMonth, yearList } from '../../lib/dobValidation';

const FormDOBInput = ({
  namePrefix = '',
}: {
  namePrefix?: string;
}): React.ReactElement => {
  const [monthDays, setMonthDays] = useState<number>(31);
  const {
    errors,
    touched,
  }: {
    values: any;
    errors: any;
    touched: any;
    setErrors: any;
  } = useFormikContext();

  const validYears = yearList();
  const onMonthChange = (value: number) => {
    setMonthDays(daysForMonth(value));
  };

  const isInvalidDate =
    !!getIn(touched, `${namePrefix}day`) &&
    !!getIn(touched, `${namePrefix}month`) &&
    !!getIn(touched, `${namePrefix}year`) &&
    (!!getIn(errors, `${namePrefix}day`) ||
      !!getIn(errors, `${namePrefix}month`) ||
      !!getIn(errors, `${namePrefix}year`));

  return (
    <>
      <FormLabel mt="12px !important">Birthday</FormLabel>
      <HStack
        mt="3px !important"
        pt="0"
        spacing={2}
        align="stretch"
        data-testid="form-dob-input"
      >
        <Field name={`${namePrefix}day`}>
          {({ field }) => (
            <FormControl isInvalid={isInvalidDate}>
              <Select
                placeholder={monthDays > 0 ? 'Day' : 'Day'}
                {...field}
                height="3.0rem"
                border="1px solid"
                borderColor="brand.grey200"
                onChange={(evt) => {
                  field.onChange(evt);
                }}
                data-testid={`${namePrefix}birth-day`}
              >
                {monthDays &&
                  Array.from(Array(monthDays).keys()).map((day) => (
                    <option value={day + 1} key={day}>
                      {day + 1}
                    </option>
                  ))}
              </Select>
            </FormControl>
          )}
        </Field>
        <Field name={`${namePrefix}month`}>
          {({ field }) => (
            <FormControl isInvalid={isInvalidDate}>
              <Select
                placeholder="Month"
                {...field}
                height="3.0rem"
                border="1px solid"
                borderColor="brand.grey200"
                onChange={(evt) => {
                  onMonthChange(parseInt(evt.target.value, 10));
                  field.onChange(evt);
                }}
                data-testid={`${namePrefix}birth-month`}
                style={{ width: 'auto' }} // issue with Month placeholder not being properly displayed
              >
                <option value="1">01</option>
                <option value="2">02</option>
                <option value="3">03</option>
                <option value="4">04</option>
                <option value="5">05</option>
                <option value="6">06</option>
                <option value="7">07</option>
                <option value="8">08</option>
                <option value="9">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </Select>
            </FormControl>
          )}
        </Field>
        <Field name={`${namePrefix}year`}>
          {({ field }) => (
            <FormControl isInvalid={isInvalidDate}>
              <Select
                placeholder="Year"
                {...field}
                height="3.0rem"
                border="1px solid"
                borderColor="brand.grey200"
                onChange={(evt) => {
                  field.onChange(evt);
                }}
                data-testid={`${namePrefix}birth-year`}
              >
                {validYears &&
                  validYears.map((year) => (
                    <option value={year} key={year}>
                      {year}
                    </option>
                  ))}
              </Select>
            </FormControl>
          )}
        </Field>
      </HStack>
      <FormControl isInvalid={isInvalidDate}>
        <FormErrorMessage marginTop="-3">
          {isInvalidDate && <div>Must be a valid date</div>}
        </FormErrorMessage>
      </FormControl>
    </>
  );
};

export default FormDOBInput;
